import React from 'react'
import'./Sidebar.css'
import {SocialIcon} from 'react-social-icons'


function Sidebar() {
  
  return (
    <div className='sidebar'>
         <button className='btnstart'>
        <div className='profile'><img style={{height:'100px',widows:'100px',borderRadius:'60px'}}
        src='https://i.ibb.co/qBGhVHp/profile.jpg' alt='img'/></div> </button>
        <div className='sidebar__icons'>
         <SocialIcon url = 'https://github.com/mikeakoolo254' style={{marginTop:'10px', height:'20px',width:'20px',paddingTop:'8px'}}/>
         <SocialIcon url ='https://www.instagram.com/maic_myke/'style={{marginTop:'5px',height:'20px',width:'20px',paddingTop:'8px'}} />
         <SocialIcon url ='https://www.linkedin.com/in/mike-akoolo-557322232/'style={{marginTop:'5px',height:'20px',width:'20px',paddingTop:'8px'}}/>
         <SocialIcon url ='https://twitter.com/mikeakoolo254' style={{marginTop:'5px',height:'20px',width:'20px',paddingTop:'8px'}}/>
         <SocialIcon url = 'https://www.youtube.com/channel/UC6p9vxdkrqvizMdnapyaUkw'style={{marginTop:'5px',height:'20px',width:'20px',paddingTop:'8px'}}/>
         <SocialIcon url ='https://stackoverflow.com/users/16898839/michael-akoolo'style={{marginTop:'5px',height:'20px',width:'20px',paddingTop:'8px'}}/>
         <SocialIcon  url ='https://web.facebook.com/MichaelBoolean/'style={{marginTop:'5px',height:'20px',width:'20px',paddingTop:'8px'}}/>
         <div className='v1'></div>
        </div>
        
    </div>
  )
}

export default Sidebar